import { useState } from 'react';
import styled from 'styled-components';

import { PAGES } from 'constants/pages';
import { getFollowingNextMondayDate, getWeekNumber } from 'helpers/dateTimes';

import { Header, HeaderTitle } from 'components/Header';
import { PageTitle } from 'components/PageTitle';
import { TotemDatePicker } from 'components/TotemDatePicker';
import { HeaderButtons } from './HeaderButtons/HeaderButtons';
import { TotemInput } from 'components/TotemInput';

export const MicrostoreMenus = () => {
    const [selectedDate, setSelectedDate] = useState<Date>(getFollowingNextMondayDate());

    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.menus} />
                </HeaderTitle>
                <HeaderContainer>
                    <TotemInput
                        className="w-[150px]"
                        value={'Semaine ' + getWeekNumber(selectedDate)}
                        onChange={() => {}}
                        disabled
                    />
                    <TotemDatePicker
                        selected={selectedDate}
                        onChange={(date) => {
                            setSelectedDate(date || getFollowingNextMondayDate());
                        }}
                    />
                </HeaderContainer>
            </Header>
            <Content>
                <ActionsSection>
                    <ActionsTitle>Actions</ActionsTitle>
                    <ActionsContainer>
                        <HeaderButtons selectedDate={selectedDate} />
                    </ActionsContainer>
                </ActionsSection>
            </Content>
        </Container>
    );
};

const HeaderContainer = styled.div`
    display: flex;
    min-width: 300px;
    margin-right: 40px;
    justify-self: end;

    & > :not(:first-child) {
        margin-left: 15px;
    }
`;

const Container = styled.div`
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const Content = styled.div`
    padding: 40px;
    flex: 1;
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: 40px;
`;

const FiltersSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

const FiltersTitle = styled.h2`
    font-size: 24px;
    font-weight: 600;
    margin: 0;
    color: ${({ theme }) => theme.textColor};
`;

const FiltersContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 30px;
    flex-wrap: wrap;
    align-items: flex-end;
`;

const FilterItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const FilterLabel = styled.label`
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.textColor};
`;

const ActionsSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

const ActionsTitle = styled.h2`
    font-size: 24px;
    font-weight: 600;
    margin: 0;
    color: ${({ theme }) => theme.textColor};
`;

const ActionsContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 20px;
    align-items: center;
`;
